import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import React, { useContext, Suspense, useState, useEffect } from "react";
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import SessionExpiryManager from "./components/SessionExpiryManager";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/tokens.css";
import "./assets/styles/toast.css";
import "./assets/styles/main.css";
import "./assets/styles/chrome.css";
import "./assets/styles/responsive.css";
import "./assets/styles/theme.css";
import "./assets/styles/components.css";
import IndexHome from "./pages/Auth/Home";
import Error from "./pages/Error";
import ForgetPassword from "./pages/ForgetPassword";
import Home from "./pages/Auth/Home";
import Profile from "./pages/Profile";
import Content from "./pages/Content";
import User from "./pages/User";
import AssistantAuditLog from "./pages/AssistantAuditLog";
import ActivityLog from "./pages/ActivityLog";
import ViewUser from "./pages/ViewUser";
import { NotificationList } from "./pages/notification/Index";
import TeamManager from "./pages/TeamManager";
import RoleManager from "./pages/RoleManager";
import BrandManager from "./pages/BrandManager";
import Clientlist from "./pages/accessModule/index";
import ViewClient from "./pages/accessModule/viewclients";
import BrandAccessControl from "./pages/AccessModule";
import CreateNewManullyBlog from "./pages/accessModule/CreateBlogManually";
import HelpCenter from "./pages/HelpCenter/Index";
import AddEditFaq from "./pages/HelpCenter/AddEditFaq";
import OnboardingManagement from "./pages/OnboardingManagement";
import CreateGraphicsRequest from "./pages/graphics/CreateGraphicsRequest";
import Workload from "./pages/Workload";
import GraphicsRequestDetail from "./pages/graphics/GraphicsRequestDetail";
import CreateBlogWriteRequest from "./pages/blogWrite/CreateBlogWriteRequest";
import BlogWriteRequestDetail from "./pages/blogWrite/BlogWriteRequestDetail";
import WritingAssistantPage from "./pages/accessModule/writingAssistant";
window.Buffer = window.Buffer || require("buffer").Buffer;
const ProtectedRoute = ({ element, permissionKey }) => {
  const user = JSON.parse(localStorage.getItem("admin_userProfile")) || {};
  const type = user?.type;
  const permissions = user?.roleId?.permission || [];

  // Allow full access if user is Admin
  if (type === "Admin") {
    return element;
  }

  // Check permission for the route
  const hasPermission = permissions.some(
    (perm) => perm.name === permissionKey && perm.view
  );

  return hasPermission ? element : <Navigate to="/" />;
};

/*************  ✨ Codeium Command ⭐  *************/
/**
 * App component which wraps the entire app with necessary providers
 * and renders the routes
 *
 * @returns {React.ReactElement} The rendered app
 */

/******  c2642731-3066-4124-a7e7-90f98ee34808  *******/function App() {

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 200);
  // }, []);

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} newestOnTop />
            <SessionExpiryManager />
            {/* {loading ? <></> : <AppRoutes />}{" "} */}
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

let publicPaths = ["/login", "/"];

const privateRoutes = (isLoggedIn) => {
  // if (!isLoggedIn) {
  //   if (!publicPaths.includes(window.location.pathname)) {
  //     return (window.location.pathname = "/login");
  //   }
  // }

  return (
    <Route
      path="/"
      element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }
    >
      <Route exact path="/" element={<IndexHome />} />
      <Route exact path="/dashboard" element={<IndexHome />} />
      <Route exact path="/profile" element={<Profile />} />
      <Route exact path="/content" element={<Content />} />
      <Route exact path="/customer-manager" element={<User />} />
      <Route exact path="/assistant-audit-log" element={<AssistantAuditLog />} />
      <Route exact path="/view-customer/:id" element={<ViewUser />} />
      <Route exact path="/notification" element={<NotificationList />} />
      <Route exact path="/team-manager" element={<TeamManager/>}/>
      <Route exact path="/role-manager"  element={<RoleManager />} />
      <Route exact path="/brand-manager"  element={<BrandManager />} />
      <Route exact path="/activity-log"  element={<ActivityLog />} />
      <Route exact path="/brand-access-control"  element={<BrandAccessControl />} />
      <Route exact path="/access-module" element={<Clientlist />} />
      <Route exact path="/view-clients/:id" element={<ViewClient />} />
      <Route exact path="/writing-assistant/:id" element={<WritingAssistantPage />} />
      <Route exact path="/create-new-manully-blog/:id" element={<CreateNewManullyBlog />} />
      <Route exact path="/graphics-requests" element={<CreateGraphicsRequest />} />
      <Route exact path="/graphics-requests/:id" element={<GraphicsRequestDetail />} />
      <Route exact path="/blog-write-requests" element={<CreateBlogWriteRequest />} />
      <Route exact path="/blog-write-requests/:id" element={<BlogWriteRequestDetail />} />
      <Route exact path="/workload" element={<Workload />} />

      {/* Help Center */}
      <Route exact path="/help-center" element={<HelpCenter />} />
      <Route exact path="/help-center/edit-faq/:id?" element={<AddEditFaq />} />

      {/* Onboarding */}
      <Route exact path="/onboarding-management" element={<OnboardingManagement />} />

      {/*
      <Route exact path="/gamer-product-manager" element={<GamerProductManager />} />
      <Route exact path="/view-gamer-product/:id" element={<ViewGamerProduct />} />

      <Route exact path="/view-user-list/:id" element={<ViewUserList />} />
      <Route exact path="/service-category" element={<ServiceCategory />} />
      <Route exact path="/product-category" element={<ProductCategory />} />



      <Route exact path="/vendor-manager/:type?" element={<ProtectedRoute element={<Vendor />} permissionKey="VendorManager" />} />
      <Route exact path="/view-vendor/:id" element={<ProtectedRoute element={<ViewVendor />} permissionKey="VendorManager" />} />
      <Route exact path="/vendor-order" element={<ProtectedRoute element={<VendorOrder />} permissionKey="VendorManager" />} />
      <Route exact path="/vendor-product" element={<ProtectedRoute element={<VendorProduct />} permissionKey="VendorManager" />} />
      <Route exact path="/vendor-product/view/:id" element={<ProtectedRoute element={<ViewVendorProduct />} permissionKey="VendorManager" />} />
      <Route exact path="/vendor-review" element={<ProtectedRoute element={<VendorReview />} permissionKey="VendorManager" />} />
      <Route exact path="/vendor-product-review/view/:id" element={<ProtectedRoute element={<ViewVendorReview />} permissionKey="VendorManager" />} />



      <Route exact path="/designer-manager/:type?" element={<ProtectedRoute element={<Designer />} permissionKey="designerManager" />} />
      <Route exact path="/view-designer/:id" element={<ProtectedRoute element={<ViewDesigner />} permissionKey="designerManager" />} />
      <Route exact path="/designer-order" element={<ProtectedRoute element={<DesignerOrder />} permissionKey="designerManager" />} />
      <Route exact path="/designer-review" element={<ProtectedRoute element={<DesignerReview />} permissionKey="designerManager" />} />
      <Route exact path="/designer-booking" element={<ProtectedRoute element={<DesignerBooking />} permissionKey="designerManager" />} />
      <Route exact path="/designer-product" element={<ProtectedRoute element={<DesignerProduct />} permissionKey="designerManager" />} />
      <Route exact path="/designer-service" element={<ProtectedRoute element={<DesignerService />} permissionKey="designerManager" />} />
      <Route exact path="/designer-service/view/:id" element={<ProtectedRoute element={<ViewDesignerService />} permissionKey="designerManager" />} />
      <Route exact path="/designer-product/view/:id" element={<ProtectedRoute element={<ViewDesignerProduct />} permissionKey="designerManager" />} />


      <Route exact path="/workshop-service" element={<ProtectedRoute element={<WorkshopService />} permissionKey="workshopManager" />} />
      <Route exact path="/workshop-service/view/:id" element={<ProtectedRoute element={<ViewWorkShopService />} permissionKey="workshopManager" />} />
      <Route exact path="/workshop-booking" element={<ProtectedRoute element={<WorkShopBooking />} permissionKey="workshopManager" />} />
      <Route exact path="/workshop-booking/view/:id" element={<ProtectedRoute element={<ViewWorkShopBooking />} permissionKey="workshopManager" />} />
      <Route exact path="/workshop-certification" element={<ProtectedRoute element={<WorkShopCertification />} permissionKey="workshopManager" />} />


      <Route exact path="/gaming-hall-mangement" element={<ProtectedRoute element={<GamingHallManagement />} permissionKey="GamingHall" />} />
      <Route exact path="/gaming-hall-mangement/view/:id" element={<ProtectedRoute element={<ViewGamingHallMangement />} permissionKey="GamingHall" />} />
      <Route exact path="/gaming-hall-event" element={<ProtectedRoute element={<GamingHallEvents />} permissionKey="GamingHall" />} />
      <Route exact path="/gaming-hall-event/view/:id" element={<ProtectedRoute element={<ViewGamingHallEvents />} permissionKey="GamingHall" />} />
      <Route exact path="/gaming-hall-review" element={<ProtectedRoute element={<GamingHallReview />} permissionKey="GamingHall" />} />
      <Route exact path="/gaming-hall-review/view/:id" element={<ProtectedRoute element={<ViewGamingHallReview />} permissionKey="GamingHall" />} />

      <Route exact path="/earning-mangement" element={<EarningManagement />} />
      <Route exact path="/membership-management" element={<Subscription/>} />
      <Route exact path="/membership-monitoring" element={<SubscriptionDetails/>} />
      <Route exact path="/transaction" element={<Transaction />} />
      <Route exact path="/banner" element={<Banner />} />
      <Route exact path="/subscription" element={<Subscription />} />
      
      {/* Help Center */}
      {/* <Route exact path="/help-center" element={<HelpCenter />} />
      <Route exact path="/help-center/edit-faq/:id?" element={<AddEditFaq />} />
      <Route exact path="/email-template" element={<EmailTemplate />} />

      {/* Finance */}
      {/* <Route exact path="/finance" element={<Finance />} /> */}
      {/* Report */}
      {/* <Route exact path="/report" element={<Reports />} />
      <Route exact path="/report/user-metrics/:id" element={<ViewUserMetrics />} />
      <Route
        exact
        path="/view-notification/:id"
        element={<ViewNotification />}
      />
      <Route
        exact
        path="/view-email-template/:id"
        element={<ViewEmailTemplate />}
      />  */}
    </Route>
  );
};

const publicRoutes = (isLoggedIn) => {
  return (
    <>
      {isLoggedIn ? (
        <Route path={"*"} element={<Home />} />
      ) : (
        <>
          <Route path="/login" element={<SignIn />} />
          <Route path="/" element={<SignIn />} />
          <Route path="/reset-password" element={<ForgetPassword />} />
        </>
      )}
    </>
  );
};

const AppRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      {publicRoutes(isLoggedIn)}
      {privateRoutes(isLoggedIn)}
      <Route path="/reset-password" element={<ForgetPassword />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
